import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import config from '../../config';
import { history } from '../../routes';
import { ToastContainer, notify } from '../../libraries/notifications';
import { formatFullname, isEmptyObject, getObjectWithJsonDataToFormValues } from '../../libraries/utils';


import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';
import Cover from '../../components/commons/Cover';
import ButtonIcon from '../../components/commons/ButtonIcon'
import Avatar from '../../components/commons/Avatar';
import MedicamentCartElement from '../../components/customs/MedicamentCartElement';
import PrescriptionPDFPrint from '../../components/customs/PrescriptionPDFPrint';

import prescriptionsActions from '../../context/prescriptions/actions';
import PDFExportButton from '../../libraries/exports/pdf';

import insurancesActions from '../../context/insurances/actions';

class Prescription extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      remove: false,
      pharmacy: null,
      prescription: null,
      from: null,
    }
  }
  
  componentDidMount() {
    if (!isEmptyObject(this.props.location.state)) { 
      const { pharmacy, from, root_id } = this.props.location.state;      
      this.setState({ pharmacy, from, root_id } ); 
    }
    this.getData();
  }

  getData = async () => {
    await this.getInsurances();
    this.getPrescription();
  }

  getInsurances = async () => {
    await this.props.onGetAllInsurances();
    const { insurances } = this.props;
    if (insurances.error) {
      notify(this.t(insurances.error.message));
    } else {
      this.setState({ insurances: insurances.items });
    }
  }

  getPrescription = async () => {
    const params = this.props.match.params;
    console.log('MY PRESCRIPTION PAGE', params, this.props.location);
    if (params.id) {
      await this.props.onGetPrescription(params.id)
      const prescription = this.props.prescriptions
      if (prescription.error){
        notify(this.t(prescription.error.message));
      } else {
        
        let prescriptionData = getObjectWithJsonDataToFormValues(
          prescription.item,
          ['id', 'date', 'type', 'status', 'duration', 'professional', 'patient', 'diagnostics', 'prescriptions_lines', 'identification', 'indications', 'duplicate','prescription_num']
        );
        const { patient } = prescriptionData;
        const ins = this.state.insurances.find(insurance => insurance.rnos === patient.insurance);
        if (ins) {
          patient.insurance_name = ins.name;
        } else {
          patient.insurance = "";
        }
        prescriptionData = { ...prescriptionData, patient };
        try {
          let url_str = window.location.href
          let url = new URL(url_str)
          if(!url){
            return
          }

          let params = new URLSearchParams(url.search);

          if(params.get("autoDownload")){
            this.setState({autoDownload: true})
          }

          if(!this.props.auth.user && !params.get("autoDownload")){
            history.push(config.ROUTES.HOME)
            return
          }
        } catch (e){}


        this.setState({ prescription: prescriptionData })
    
      } 
    }
  }

  componentWillUnmount() {
    this.props.onClearCurrent(); 
  }

  gotoBack = () => {
    const {from, root_id} = this.state;
    history.push(root_id ? config.ROUTES.CHAT.replace(':root_id', root_id) : ( from ? from : config.ROUTES.PRESCRIPTIONS));
  }


  gotoDownload = () => {
    console.log('DOWNLOAD');
  }
  
  gotoPrint = () => {
    console.log('PRINT');
  }

  gotoShare = () => {
    console.log('SHARE');
  }

  gotoNext = () => {
    const { prescription } = this.state;
    history.push({
      pathname: config.ROUTES.PURCHASES.CART,
      state: {
        prescriptions: [prescription],
        from: config.ROUTES.PRESCRIPTION.replace(':id', prescription.id)
      }
    })
  };

  
  render() {
    
    const { prescription } = this.state;
    const { professional } = prescription || {}; 
    const { patient } = prescription || {}; 
    const date = prescription && new Date(prescription.date) 
    
    return (
      <LayoutSmall
        main={{ className: ""}}
        header={{
          className: "!bg-transparent fixed",
          left: { icon: 'arrow_left', action: this.gotoBack },
        }}
        container={{ className: "px-0"}}
        loading={this.props.prescriptions.loading}
      >
        <ToastContainer/>
        { !this.props.prescriptions.loading && prescription && !this.state.autoDownload && ( 
          <>
            <Cover image={null} />
            <section className="section-card">
              <div className="flex flex-col place-items-center border-b pb-3">
                <Avatar
                  image={professional.profile_image}
                  label={professional.username}
                  className="rounded-full w-28 h-28"
                  containerClassName="-mt-20 z-20 border-white border-4 mb-2"
                />  
                <p className="text-center">
                  {this.t("Realizado por")} 
                  <span className="block font-bold text-primary">{formatFullname(professional)}</span>
                </p>
                  
              </div>
              
                <div className="py-3 border-b">
                  {(prescription.type === config.PRESCRIPTIONS.TYPE.PHARMACY) && 
                  <>
                  <h3 className="mb-1">{this.t("Medicamentos")}</h3>
                  { prescription.prescriptions_lines.map((line, index) =>{ 
                    const medicament = line.json_data.medicament
                    return (
                      <MedicamentCartElement key={index} medicament={medicament} prescription={false}/>
                    )
                  })}
                  </>}
                  {(prescription.type === config.PRESCRIPTIONS.TYPE.INDICATIONS) && 
                  <>
                    <h3 className="mb-1">{this.t("Indicaciones")}</h3>
                    <p>{prescription.indications}</p>
                  </>}
                </div>
                <div className="py-3 border-b">
                  <h3 className="mb-1">{this.t("Diagnósticos")}</h3>
                  { prescription.diagnostics.map((diagnostic, index) =>{ 
                      return(
                        <p className="text-gray-500" key={index}>
                          {diagnostic.name}
                        </p>
                      )
                    })}
                </div>
                {(prescription.type === config.PRESCRIPTIONS.TYPE.PHARMACY) && 
                <div className="py-3 border-b">
                  <h4 className="mb-1">{this.t("Duración")}</h4>
                  <p className="text-gray-500">{prescription.duration}</p>
                </div>}
              <div className="flex items-center mt-10">
                {/*<ButtonIcon buttonClassName="btn-ghost mr-1" icon="printer" onClick={this.gotoPrint}/>
                <ButtonIcon buttonClassName="btn-ghost mr-1" icon="share" onClick={this.gotoShare}/>*/}
                {(prescription.prescriptions_lines.length !== 0) && 
                  <>
                   <PDFExportButton htmlId="print-pdf" icon="download" prescription_id={prescription.id}/>
                  <Button
                    className="btn-primary btn-md flex-1"
                    title={this.t("Encargar en farmacia")}
                    onClick={this.gotoNext}
                    disabled={prescription.status === config.PRESCRIPTIONS.STATUS.INACTIVE}
                  />
                  </>}
              </div>
               {/*print_pdf*/}
                <PrescriptionPDFPrint htmlId="print-pdf" prescription={prescription} professional={professional} patient={patient} date={date}/>
                {/*print_pdf*/}
              
              
            </section>
          </>
        )}
        {this.state.autoDownload && prescription && <>
          <PDFExportButton htmlId="print-pdf" icon="download" prescription_id={prescription.id} autoDownload={this.state.autoDownload}/>
          {/*print_pdf*/}
          <PrescriptionPDFPrint htmlId="print-pdf" prescription={prescription} professional={professional} patient={patient} date={date}/>
          {/*print_pdf*/}
        </>}
      </LayoutSmall>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    prescriptions: state.prescriptions.current,
    insurances: state.insurances.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetPrescription: (id) => dispatch(prescriptionsActions.get(id)),
    onClearCurrent: (id) => dispatch(prescriptionsActions.clearCurrent()),
    onGetAllInsurances: (params) => dispatch(insurancesActions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Prescription));
